import { memo, useCallback } from 'react'
import { TableColumnsType, Table } from 'antd'
import { TeamsRatings } from 'types/teams-ratings'

type Props = {
    data: TeamsRatings[]
}

export const ExpandableRow = memo((props: Props) => {
    const { data } = props

    const columns: TableColumnsType<TeamsRatings> = [
        { title: 'League Type', dataIndex: ['leagueType', 'name'] },
        { title: 'League Division', dataIndex: ['leagueDivision', 'name'] },
        { title: 'Old Rating', dataIndex: 'oldRating' },
        { title: 'Rating', dataIndex: 'rating' },
        { title: 'Wins', dataIndex: 'wins' },
        { title: 'Draws', dataIndex: 'draws' },
        { title: 'Losses', dataIndex: 'losses' },
    ]

    const getRowKey = useCallback((record: TeamsRatings) => {
        return `${record.teamId}-${record.leagueType.id}-${record.leagueDivision.id}`
    }, [])

    return (
        <>
            <Table columns={columns} dataSource={data} pagination={false} rowKey={getRowKey} />
        </>
    )
})
